<template>
  <div>
    <v-menu v-model="clientMenu" offset-y max-width="300px">
      <template #activator="{ on }">
        <v-list-item
          v-on="on"
          draggable="true"
          @dragstart="onDragStart"
          @dragend="onDragEnd"
          :class="{ 'dragging-client': isDragging }"
        >
          <v-list-item-avatar>
            <client-avatar
              :clientDbId="client.clientDatabaseId"
            ></client-avatar>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="client-title-row">
              <span class="client-left">
                <span class="client-nick">
                  {{ nickPrefix }}{{ client.clientNickname }}
                </span>
                <v-icon small class="ml-1">{{ statusIcon }}</v-icon>
              </span>

              <span class="client-right">
                <span
                  v-for="g in clientGroupIcons"
                  :key="g.iconid + '-' + g.sgid"
                  class="ml-1 d-inline-flex align-center"
                >
                  <v-tooltip bottom>
                    <template #activator="{ on: onTip, attrs }">
                      <v-img
                        v-if="getGroupIconSrc(g.iconid)"
                        v-bind="attrs"
                        v-on="onTip"
                        :src="getGroupIconSrc(g.iconid)"
                        max-width="16"
                        max-height="16"
                        class="d-inline-block"
                        contain
                      />
                    </template>
                    <span>{{ g.name }}</span>
                  </v-tooltip>
                </span>
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-list>
        <v-list-item @click="pokeClientDialog = true">
          <v-list-item-action
            ><v-icon>mdi-alert-octagram</v-icon></v-list-item-action
          >
          <v-list-item-content>
            <v-list-item-title>Kullanıcıyı Dürt (Poke)</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="openPrivateChat(client.clid)">
          <v-list-item-action><v-icon>send</v-icon></v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Özel Sohbet Aç</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{ name: 'client-edit', params: { clid: client.clid } }"
        >
          <v-list-item-action><v-icon>edit</v-icon></v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Kullanıcıyı Düzenle</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="serverGroupsDialog = true">
          <v-list-item-action
            ><v-icon>mdi-account-multiple</v-icon></v-list-item-action
          >
          <v-list-item-content>
            <v-list-item-title>Sunucu Grupları</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="openMoveDialog">
          <v-list-item-action
            ><v-icon>mdi-swap-horizontal</v-icon></v-list-item-action
          >
          <v-list-item-content>
            <v-list-item-title>Kullanıcıyı Taşı</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="openKickDialog(4)">
          <v-list-item-action><v-icon>forward</v-icon></v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Kullanıcıyı Kanaldan At</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="openKickDialog(5)">
          <v-list-item-action><v-icon>forward</v-icon></v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Kullanıcıyı Sunucudan At</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{
            name: 'client-ban',
            params: { cldbid: client.clientDatabaseId },
          }"
        >
          <v-list-item-action
            ><v-icon>not_interested</v-icon></v-list-item-action
          >
          <v-list-item-content>
            <v-list-item-title>Kullanıcıyı Banla</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Kullanıcı Bilgisi -->
        <v-list-item
          @click.stop="
            clientMenu = false;
            openClientInfo();
          "
        >
          <v-list-item-action
            ><v-icon>mdi-account-details</v-icon></v-list-item-action
          >
          <v-list-item-content>
            <v-list-item-title>Kullanıcı Bilgisi</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- SERVER GROUPS DIALOG -->
    <v-dialog v-model="serverGroupsDialog" max-width="900">
      <v-card>
        <v-card-title class="d-flex align-center">
          <span>Sunucu Grupları</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="serverGroupsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="groupSearch"
            dense
            outlined
            clearable
            prepend-inner-icon="mdi-magnify"
            label="Grup ara"
          />

          <v-container fluid>
            <v-row>
              <!-- ServerQuery Yetkileri (LOCKED) -->
              <v-col cols="12" v-if="filteredGroupsServerQuery.length">
                <div class="group-section-title">ServerQuery Yetkileri</div>
              </v-col>

              <v-col
                v-for="g in filteredGroupsServerQuery"
                :key="'q-' + g.sgid"
                cols="12"
                sm="6"
                md="4"
                lg="3"
              >
                <v-card
                  class="pa-2 d-flex align-center group-card group-card--disabled"
                  outlined
                >
                  <v-icon class="mr-2" small color="grey">mdi-lock</v-icon>
                  <div class="text-truncate" :title="g.name">{{ g.name }}</div>
                </v-card>
              </v-col>

              <!-- Template (clickable) -->
              <v-col cols="12" v-if="filteredGroupsTemplate.length">
                <div class="group-section-title">Template</div>
              </v-col>

              <v-col
                v-for="g in filteredGroupsTemplate"
                :key="'t-' + g.sgid"
                cols="12"
                sm="6"
                md="4"
                lg="3"
              >
                <v-card
                  class="pa-2 d-flex align-center group-card"
                  outlined
                  @click="toggleServerGroup(g)"
                  style="cursor: pointer"
                >
                  <v-icon class="mr-2" small>
                    {{
                      hasServerGroup(g.sgid)
                        ? "mdi-checkbox-marked"
                        : "mdi-checkbox-blank-outline"
                    }}
                  </v-icon>
                  <div class="text-truncate" :title="g.name">{{ g.name }}</div>
                </v-card>
              </v-col>

              <!-- Normal (clickable) -->
              <v-col cols="12" v-if="filteredGroupsNormal.length">
                <div class="group-section-title">Normal Gruplar</div>
              </v-col>

              <v-col
                v-for="g in filteredGroupsNormal"
                :key="'n-' + g.sgid"
                cols="12"
                sm="6"
                md="4"
                lg="3"
              >
                <v-card
                  class="pa-2 d-flex align-center group-card"
                  outlined
                  @click="toggleServerGroup(g)"
                  style="cursor: pointer"
                >
                  <v-icon class="mr-2" small>
                    {{
                      hasServerGroup(g.sgid)
                        ? "mdi-checkbox-marked"
                        : "mdi-checkbox-blank-outline"
                    }}
                  </v-icon>
                  <div class="text-truncate" :title="g.name">{{ g.name }}</div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- KICK DİYALOĞU -->
    <v-dialog v-model="kickClientDialog" max-width="500px">
      <v-card>
        <v-card-title>{{ destination }} Üzerinden At</v-card-title>
        <v-card-text>
          <v-text-field label="Atma Sebebi" v-model="reason"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="kickClientDialog = false" color="primary"
            >İptal</v-btn
          >
          <v-btn text @click="kick" color="primary">Tamam</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- POKE DİYALOĞU -->
    <v-dialog v-model="pokeClientDialog" max-width="500px">
      <v-card>
        <v-card-title>Poke</v-card-title>
        <v-card-text>
          <v-text-field
            label="Poke Mesajı"
            v-model="pokeMessage"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="pokeClientDialog = false" color="primary"
            >İptal</v-btn
          >
          <v-btn text @click="poke" color="primary">Gönder</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- TAŞI DİYALOĞU -->
    <v-dialog v-model="moveClientDialog" max-width="520px">
      <v-card>
        <v-card-title>Kullanıcıyı Taşı</v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="targetCid"
            :items="channels"
            item-text="label"
            item-value="cid"
            label="Hedef kanal"
            clearable
            dense
            outlined
            :loading="channelsLoading"
            no-data-text="Kanal bulunamadı"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="moveClientDialog = false"
            >İptal</v-btn
          >
          <v-btn
            text
            color="primary"
            :disabled="!targetCid || moving"
            :loading="moving"
            @click="moveClient"
          >
            Taşı
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Kullanıcı Bilgisi Dialog -->
    <v-dialog v-model="clientInfoDialog" max-width="900" scrollable>
      <v-card>
        <v-card-title class="d-flex align-center">
          <span>Kullanıcı Bilgisi</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="clientInfoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-progress-linear
            v-if="clientInfoLoading"
            indeterminate
            class="mb-3"
          ></v-progress-linear>

          <v-simple-table dense>
            <tbody>
              <tr>
                <td><b>Nick</b></td>
                <td class="text-right">{{ safe(clientInfo.nick) }}</td>
              </tr>

              <tr>
                <td><b>UID</b></td>
                <td class="text-right">
                  <span>{{ safe(clientInfo.uid) }}</span>
                  <v-btn icon x-small @click="copyText(clientInfo.uid)">
                    <v-icon small>mdi-content-copy</v-icon>
                  </v-btn>
                </td>
              </tr>

              <tr>
                <td><b>IP</b></td>
                <td class="text-right">
                  <span>{{ safe(clientInfo.ip) }}</span>
                  <v-btn icon x-small @click="copyText(clientInfo.ip)">
                    <v-icon small>mdi-content-copy</v-icon>
                  </v-btn>
                </td>
              </tr>

              <tr>
                <td><b>Platform</b></td>
                <td class="text-right">{{ safe(clientInfo.platform) }}</td>
              </tr>

              <tr>
                <td><b>Versiyon</b></td>
                <td class="text-right">{{ safe(clientInfo.version) }}</td>
              </tr>

              <tr>
                <td><b>Hesap Oluşturma</b></td>
                <td class="text-right">{{ createdPretty }}</td>
              </tr>

              <tr>
                <td><b>Son Bağlantı</b></td>
                <td class="text-right">{{ lastConnectedPretty }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="
              clientInfoDialog = false;
              clientMenu = false;
            "
            >Kapat</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  components: {
    ClientAvatar: () => import("@/components/ClientAvatar"),
  },
  props: {
    client: Object,
    serverGroups: Array,
  },
  data() {
    return {
      // ===== DİYALOGLAR =====
      serverGroupsDialog: false,
      kickClientDialog: false,
      pokeClientDialog: false,
      moveClientDialog: false,
      clientInfoDialog: false,

      // ===== FORM / INPUT =====
      groupSearch: "",
      pokeMessage: "",
      reason: "",
      destination: "",
      reasonid: null,

      // ===== DRAG / MOVE =====
      isDragging: false,
      channelsLoading: false,
      moving: false,
      channels: [],
      targetCid: null,

      // ===== KULLANICI BİLGİLERİ (TEK KAYNAK) =====
      clientMenu: false,
      clientInfoDialog: false,
      clientInfoLoading: false,

      clientInfo: {
        // ✅ template bunu basacak
        nick: "",
        uid: "",
        ip: "",
        platform: "",
        version: "",
      },

      clientInfoRaw: {}, // ✅ TS clientinfo ham
      clientDbInfo: {}, // ✅ clientdbinfo
    };
  },

  computed: {
    groupSearchLower() {
      return String(this.groupSearch || "")
        .toLowerCase()
        .trim();
    },

    clientServergroupsList() {
      var raw =
        (this.client &&
          (this.client.clientServergroups ||
            this.client.client_servergroups)) ||
        "";
      return String(raw)
        .split(",")
        .map(function (x) {
          return Number(x);
        })
        .filter(Boolean);
    },

    sortedServerGroups() {
      return (this.serverGroups || []).slice().sort(function (a, b) {
        return Number((a && a.sortid) || 0) - Number((b && b.sortid) || 0);
      });
    },

    groupsTemplate() {
      return this.sortedServerGroups.filter(function (g) {
        return Number(g && g.type) === 0;
      });
    },
    groupsNormal() {
      return this.sortedServerGroups.filter(function (g) {
        return Number(g && g.type) === 1;
      });
    },
    groupsServerQuery() {
      return this.sortedServerGroups.filter(function (g) {
        return Number(g && g.type) === 2;
      });
    },

    filteredGroupsTemplate() {
      var q = this.groupSearchLower;
      var list = this.groupsTemplate || [];
      if (!q) return list;
      return list.filter(function (g) {
        return String((g && g.name) || "")
          .toLowerCase()
          .includes(q);
      });
    },
    filteredGroupsNormal() {
      var q = this.groupSearchLower;
      var list = this.groupsNormal || [];
      if (!q) return list;
      return list.filter(function (g) {
        return String((g && g.name) || "")
          .toLowerCase()
          .includes(q);
      });
    },
    filteredGroupsServerQuery() {
      var q = this.groupSearchLower;
      var list = this.groupsServerQuery || [];
      if (!q) return list;
      return list.filter(function (g) {
        return String((g && g.name) || "")
          .toLowerCase()
          .includes(q);
      });
    },

    // --- nick prefix (namemode>0) ---
    nickPrefix() {
      var shown = (this.clientGroupIcons || [])
        .filter(function (g) {
          return Number((g && g.namemode) || 0) > 0;
        })
        .slice()
        .sort(function (a, b) {
          return Number((a && a.sortid) || 0) - Number((b && b.sortid) || 0);
        });

      if (!shown.length) return "";
      return (
        shown
          .map(function (g) {
            return "[" + g.name + "]";
          })
          .join(" ") + " "
      );
    },

    statusIcon() {
      var c = this.client || {};
      if (c.clientAway) return "cancel_presentation";
      if (c.clientOutputMuted) return "volume_off";
      if (c.clientInputMuted) return "mic_off";
      return "";
    },

    // --- group icons ---
    clientGroupIcons() {
      var sgids = this.clientServergroupsList;
      if (!sgids.length) return [];

      var toIconId = function (v) {
        var n = parseInt(String(v || "").replace(/^icon_/i, ""), 10);
        if (!isFinite(n)) return 0;
        if (n < 0) n = 4294967296 + n;
        return n;
      };

      var m = {};
      (this.serverGroups || []).forEach(function (g) {
        m[Number(g.sgid)] = g;
      });

      return sgids
        .map(function (sgid) {
          return m[sgid];
        })
        .filter(Boolean)
        .map(function (g) {
          return {
            name: g.name,
            iconid: toIconId(g.iconid),
            sgid: Number(g.sgid),
            namemode: Number(g.namemode || 0),
            sortid: Number(g.sortid || 0),
            type: Number(g.type || 0),
          };
        })
        .filter(function (x) {
          return x.iconid > 0;
        });
    },

    // ===== USER INFO (Vue2 safe) =====
    uid() {
      var ci = this.clientInfo || {};
      var c = this.client || {};
      return (
        ci.clientUniqueIdentifier ||
        ci.client_unique_identifier ||
        c.clientUniqueIdentifier ||
        c.client_unique_identifier ||
        "-"
      );
    },

    ip() {
      var ci = this.clientInfo || {};
      var c = this.client || {};
      return (
        ci.connectionClientIp ||
        ci.connection_client_ip ||
        c.connectionClientIp ||
        c.connection_client_ip ||
        c.clientLastip ||
        c.client_lastip ||
        "-"
      );
    },

    platform() {
      var ci = this.clientInfo || {};
      return ci.clientPlatform || ci.client_platform || "-";
    },

    createdPretty() {
      var db = this.clientDbInfo || {};
      var t = Number(db.client_created || 0);
      return t ? new Date(t * 1000).toLocaleString() : "-";
    },

    lastConnectedPretty() {
      // listede görünen client = online
      if (this.client && this.client.clid) return "Online";

      var t = Number(this.clientDbInfo.client_lastconnected || 0);
      return t ? new Date(t * 1000).toLocaleString() : "-";
    },
  },

  mounted() {
    this.fetchMissingGroupIcons();
  },

  watch: {
    clientGroupIcons() {
      this.fetchMissingGroupIcons();
    },
  },

  methods: {
    onDragStart(e) {
      this.isDragging = true;

      const payload = {
        clid: Number(this.client && this.client.clid),
        nick: String((this.client && this.client.clientNickname) || ""),
      };

      // Firefox için şart
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/plain", JSON.stringify(payload));
    },
    onDragEnd() {
      this.isDragging = false;
    },

    isSpacerChannelName(raw) {
      return /^\s*\[[^\]]*spacer[^\]]*\]/i.test(String(raw || ""));
    },
    stripSpacerTag(raw) {
      let s = String(raw || "");
      while (/^\s*\[[^\]]*spacer[^\]]*\]/i.test(s)) {
        s = s.replace(/^\s*\[[^\]]*spacer[^\]]*\]\s*/i, "");
      }
      return s.trim();
    },
    renderSpacerText(raw, targetLen = 70) {
      const base = this.stripSpacerTag(raw) || "─";
      const repeat = Math.max(1, Math.ceil(targetLen / base.length));
      return base.repeat(repeat);
    },

    isAssignableGroup(g) {
      return Number(g && g.type) !== 2;
    },

    hasServerGroup(sgid) {
      return this.clientServergroupsList.includes(Number(sgid));
    },

    async toggleServerGroup(group) {
      if (!this.isAssignableGroup(group)) {
        this.$toast &&
          this.$toast.info("Bu grup (ServerQuery) değiştirilemez.");
        return;
      }

      const sgid = Number(group.sgid);
      const cldbid = this.client && this.client.clientDatabaseId;
      if (!cldbid || !sgid) return;

      const before = this.clientServergroupsList.slice();
      const has = before.includes(sgid);
      const after = has ? before.filter((x) => x !== sgid) : [...before, sgid];

      this.$set(this.client, "clientServergroups", after.join(","));

      try {
        if (has) {
          await this.$TeamSpeak.execute("servergroupdelclient", {
            sgid,
            cldbid,
          });
          this.$toast && this.$toast.success(`Grup kaldırıldı: ${group.name}`);
        } else {
          await this.$TeamSpeak.execute("servergroupaddclient", {
            sgid,
            cldbid,
          });
          this.$toast && this.$toast.success(`Grup eklendi: ${group.name}`);
        }
      } catch (err) {
        this.$set(this.client, "clientServergroups", before.join(","));

        const msg =
          typeof trTeamSpeakError === "function"
            ? await trTeamSpeakError(err)
            : (err && err.message) || "İşlem başarısız";

        this.$toast && this.$toast.error(String(msg));
      }
    },

    async fetchMissingGroupIcons() {
      const ids = (this.clientGroupIcons || [])
        .map((g) => Number(g.iconid))
        .filter((n) => Number.isFinite(n) && n > 0);

      if (!ids.length) return;

      // ikon indirme işini store aksiyonuna bırak
      await this.$store.dispatch("groupIcons/getGroupIcons", ids);
    },

    getGroupIconSrc(iconid) {
      const mod =
        this.$store && this.$store.state && this.$store.state.groupIcons;
      if (!mod || !mod.files) return null;

      const f = mod.files.find((x) => Number(x.iconid) === Number(iconid));
      if (f && f.base64) return `data:image/png;base64,${f.base64}`;
      return null;
    },

    async poke() {
      try {
        await this.$TeamSpeak.execute("clientpoke", {
          msg: this.pokeMessage,
          clid: this.client.clid,
        });
      } catch (err) {
        this.$toast && this.$toast.error(err.message);
      }
      this.pokeMessage = "";
      this.pokeClientDialog = false;
    },

    openKickDialog(reasonid) {
      this.reasonid = reasonid;
      this.destination =
        reasonid === 4 ? "Kanal" : reasonid === 5 ? "Sunucu" : "";
      this.kickClientDialog = true;
    },

    async kick() {
      try {
        await this.$TeamSpeak.execute("clientkick", {
          reasonid: this.reasonid,
          reasonmsg: this.reason,
          clid: this.client.clid,
        });
      } catch (err) {
        const msg =
          typeof trTeamSpeakError === "function"
            ? await trTeamSpeakError(err)
            : (err && err.message) || "Hata";

        this.$toast && this.$toast.error(String(msg));
      }
      this.kickClientDialog = false;
    },

    async openMoveDialog() {
      this.moveClientDialog = true;
      this.targetCid = null;

      // daha önce çektiysek tekrar çekme
      if (this.channels.length) return;

      this.channelsLoading = true;
      try {
        const list = await this.$TeamSpeak.execute("channellist", {
          "-flags": 1,
        });

        // TS3 lib genelde array döndürür; ama garanti olsun
        const channels = Array.isArray(list)
          ? list
          : (list && (list.channels || list.data)) || [];

        const byPid = new Map();
        channels.forEach((c) => {
          const cid = Number(c.cid);
          const pid = Number(c.pid || 0);
          if (!byPid.has(pid)) byPid.set(pid, []);
          byPid.get(pid).push(c);
        });

        // sadece [*spacer] prefixini temizle, kanal adını öldürme
        const stripSpacerPrefix = (raw) => {
          let s = String(raw || "");
          // "[*spacer]" / "[cspacer]" / "[lspacer]" gibi baştaki etiketi at
          while (/^\[[^\]]*spacer[^\]]*\]/i.test(s)) {
            s = s.replace(/^\[[^\]]*spacer[^\]]*\]/i, "");
          }
          return s.trim();
        };

        const getChannelDisplayName = (ch) => {
          const cid = Number(ch.cid);
          // ✅ asıl fix burada: channelName’i de oku
          const rawName =
            (ch &&
              (ch.channelName ||
                ch.channel_name ||
                ch.channel_name_phonetic ||
                ch.name ||
                ch.channelname)) ||
            "";

          const clean = stripSpacerPrefix(rawName);
          return clean || `Kanal ${cid}`;
        };

        // çocukları TS3 order'a göre sırala
        for (const arr of byPid.values()) {
          arr.sort(
            (a, b) =>
              Number(a.channelOrder || a.channel_order || 0) -
              Number(b.channelOrder || b.channel_order || 0)
          );
        }

        const out = [];
        const walk = (pid, depth) => {
          const kids = byPid.get(pid) || [];
          for (const ch of kids) {
            const cid = Number(ch.cid);
            const label = getChannelDisplayName(ch);
            out.push({
              cid,
              label: `${"— ".repeat(depth)}${label}`,
            });
            walk(cid, depth + 1);
          }
        };

        walk(0, 0);
        this.channels = out;
      } catch (err) {
        this.$toast && this.$toast.error(err.message);
      } finally {
        this.channelsLoading = false;
      }
    },

    async moveClient() {
      if (!this.targetCid) return;

      this.moving = true;
      try {
        await this.$TeamSpeak.execute("clientmove", {
          clid: this.client.clid,
          cid: this.targetCid,
        });
        this.$toast && this.$toast.success("Kullanıcı taşındı");
        this.moveClientDialog = false;
      } catch (err) {
        const msg =
          typeof trTeamSpeakError === "function"
            ? await trTeamSpeakError(err)
            : (err && err.message) || "Hata";

        this.$toast && this.$toast.error(String(msg));
      } finally {
        this.moving = false;
      }
    },

    openPrivateChat(clid) {
      this.$router.push({ name: "chat", query: { client: clid } });
    },
    safe(v) {
      if (v === undefined || v === null) return "";
      return String(v);
    },

    copyText(txt) {
      const t = String(txt || "");
      if (!t) {
        this.$toast && this.$toast.info("Kopyalanacak veri yok");
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(t);
        this.$toast && this.$toast.success("Kopyalandı");
        return;
      }

      // fallback
      const el = document.createElement("textarea");
      el.value = t;
      el.setAttribute("readonly", "");
      el.style.position = "fixed";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      try {
        document.execCommand("copy");
        this.$toast && this.$toast.success("Kopyalandı");
      } catch (e) {
        this.$toast && this.$toast.error("Kopyalama başarısız");
      }
      document.body.removeChild(el);
    },

    async openClientInfo() {
      if (this.clientInfoLoading) return;

      this.clientInfoDialog = true;
      this.clientInfoLoading = true;

      try {
        var c = this.client || {};
        var clid = c.clid;
        var cldbid = c.clientDatabaseId || c.client_database_id;

        if (!clid) throw new Error("clid yok");

        // 1) clientinfo
        var infoRes = await this.$TeamSpeak.execute("clientinfo", {
          clid: clid,
        });
        this.clientInfo = Array.isArray(infoRes)
          ? infoRes[0] || {}
          : infoRes || {};

        // alanları toparla
        var nick =
          this.clientInfo.clientNickname ||
          this.clientInfo.client_nickname ||
          c.clientNickname ||
          "";

        var uid =
          this.clientInfo.clientUniqueIdentifier ||
          this.clientInfo.client_unique_identifier ||
          c.clientUniqueIdentifier ||
          c.client_unique_identifier ||
          "";

        var ip =
          this.clientInfo.connectionClientIp ||
          this.clientInfo.connection_client_ip ||
          c.connectionClientIp ||
          c.connection_client_ip ||
          c.clientLastip ||
          c.client_lastip ||
          "";

        var platform =
          this.clientInfo.clientPlatform ||
          this.clientInfo.client_platform ||
          "";

        var version =
          this.clientInfo.clientVersion || this.clientInfo.client_version || "";

        // 2) clientdbinfo (created / lastconnected)
        this.clientDbInfo = {};
        if (cldbid) {
          var dbRes = await this.$TeamSpeak.execute("clientdbinfo", {
            cldbid: cldbid,
          });
          this.clientDbInfo = Array.isArray(dbRes)
            ? dbRes[0] || {}
            : dbRes || {};
        }

        // Dialogda basacağın tek obje
        this.clientInfo = {
          nick: nick,
          uid: uid,
          ip: ip,
          platform: platform,
          version: version,
        };
      } catch (err) {
        var msg =
          err && err.message ? err.message : "Kullanıcı bilgisi alınamadı";
        if (this.$toast && this.$toast.error) this.$toast.error(msg);

        this.clientInfo = {
          nick: "",
          uid: "",
          ip: "",
          platform: "",
          version: "",
        };
        this.clientDbInfo = {};
      } finally {
        this.clientInfoLoading = false;
      }
    },
    async tsTry(commands) {
      let lastErr = null;
      for (const c of commands) {
        try {
          const res = await this.$TeamSpeak.execute(
            c.cmd,
            c.params || {},
            c.options || []
          );
          return res;
        } catch (e) {
          lastErr = e;
        }
      }
      throw lastErr || new Error("Komut çalışmadı");
    },
  },
};
</script>

<style scoped>
* {
  text-transform: none !important;
}
.client-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
}
.client-left {
  display: inline-flex;
  align-items: center;
  min-width: 0;
}
.client-nick {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.client-right {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
}
.group-section-title {
  font-weight: 700;
  opacity: 0.85;
  padding: 6px 2px;
}
.group-card--disabled {
  opacity: 0.55;
  cursor: not-allowed !important;
}
.dragging-client {
  opacity: 0.6;
}
.chip-ok {
  background: #1b5e20 !important;
  color: #fff !important;
}
.chip-mid {
  background: #f9a825 !important;
  color: #111 !important;
}
.chip-bad {
  background: #b71c1c !important;
  color: #fff !important;
}
</style>
